import React from 'react';
import { FiSearch } from 'react-icons/fi';
import HierarchyFilterDropdowns from '../filters/HierarchyFilterDropdowns';
import styles from './TableToolbar.module.css';

/**
 * Shared table toolbar: rounded pill search on the left, optional chip
 * filters (Filter By, All Areas, …) on the right.
 *
 * Usage:
 *   <TableToolbar
 *     searchValue={q}
 *     onSearchChange={setQ}
 *     hierarchy={hierarchyFiltersFromUseHierarchyFilters}
 *   />
 */
export default function TableToolbar({
  searchValue = '',
  onSearchChange,
  searchPlaceholder = 'Search by Keywords',
  hierarchy = null,
  rightSlot = null,
  className = '',
}) {
  return (
    <div className={[styles.toolbar, className].filter(Boolean).join(' ')}>
      <div className={styles.search}>
        <FiSearch className={styles.searchIcon} aria-hidden="true" />
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(e) => onSearchChange?.(e.target.value)}
          aria-label={searchPlaceholder}
        />
      </div>

      {(hierarchy || rightSlot) && (
        <div className={styles.filters}>
          {hierarchy ? (
            <HierarchyFilterDropdowns
              filterByOptions={hierarchy.filterByDropdownOptions}
              locationOptions={hierarchy.locationDropdownOptions}
              filterByField={hierarchy.filterByField}
              locationFilter={hierarchy.locationFilter}
              onFilterByChange={hierarchy.onFilterByChange}
              onLocationChange={hierarchy.setLocationFilter}
              locationPlaceholder={hierarchy.locationPlaceholder}
            />
          ) : null}
          {rightSlot}
        </div>
      )}
    </div>
  );
}
